import { EmploymentDto, PersonDto } from "@app/api2/api";
import { useFormikContext } from "formik";
import { Header, FormGroup as SFormGroup } from "@/components/bp/bp-ui";
import SemanticFormikInput from "@common/Forms/SemanticFormikInput";
import SemanticFormikSelect from "@common/Forms/SemanticFormikSelect";
import { keyOfCheckerNested } from "@common/Utils";
import { useCityOptions, useCountryOptions, useStateOptions } from "../../Hooks/LookupOptions";
import { SectionWithInfo } from "../components/SectionWithInfo";
import { EnrollmentFormSectionWithRepeater } from "../components/EnrollmentFormSection";

const fn = keyOfCheckerNested<PersonDto>();

export const ProfessionalTab = () => {
    const { values } = useFormikContext<PersonDto>();

    return (
        <SectionWithInfo title="Professional Information" info="List the individual's employment history. Add each position as a separate entry.">
            <EnrollmentFormSectionWithRepeater sectionKey="employment_history" header="Employment History"
                instanceType={values}
                name="employmentHistory"
                newItemFactory={() => ({
                    occupation: '',
                    employerName: '',
                    employerCountryId: undefined,
                    employerAddressId: undefined,
                    employerAddressLine1: '',
                    employerAddressLine2: '',
                    employerCityId: undefined,
                    employerStateId: undefined,
                    employerPostalCode: '',
                    empPhone: '',
                    startDate: '' as any,
                    endDate: '' as any,
                    employerCityName: '',
                    employerId: undefined,
                    employerStateName: '',
                    id: undefined,
                } as EmploymentDto)}
                addButtonLabel="Add Employment">
                {({ editMode, idx, item }) => (
                    <EmploymentRow editMode={editMode} key={idx} idx={idx} employer={item}></EmploymentRow>
                )}
            </EnrollmentFormSectionWithRepeater>
        </SectionWithInfo>
    );
};

function EmploymentRow(props: { idx: number; employer: EmploymentDto; editMode: boolean; }) {

    const country = useCountryOptions({ defaultValue: props.employer.employerCountryId });
    const state = useStateOptions({ defaultValue: props.employer.employerStateId, countryId: props.employer.employerCountryId });
    const cities = useCityOptions({ defaultValue: props.employer.employerCityId, countryId: props.employer.employerCountryId, stateId: props.employer.employerStateId });

    return (<>
        <Header as="h4" size="tiny">Job Information</Header>
        <SFormGroup widths="equal">
            <SemanticFormikInput disabled={!props.editMode} name={fn(`employmentHistory.${props.idx}.occupation`)} label="Occupation" maxLength={100} required />
            <SemanticFormikInput disabled={!props.editMode} name={fn(`employmentHistory.${props.idx}.employerName`)} label="Employer Name" maxLength={200} required />
        </SFormGroup>
        <Header as="h4" size="tiny">Employer Address</Header>
        <SFormGroup widths="equal">
            <SemanticFormikInput disabled={!props.editMode} name={fn(`employmentHistory.${props.idx}.employerAddressLine1`)} label="Address Line 1" maxLength={100} required />
            <SemanticFormikInput disabled={!props.editMode} name={fn(`employmentHistory.${props.idx}.employerAddressLine2`)} label="Address Line 2" maxLength={100} />
        </SFormGroup>
        <SFormGroup widths="equal">
            <SemanticFormikSelect disabled={!props.editMode} name={fn(`employmentHistory.${props.idx}.employerCountryId`)} label="Country" placeholder="Select Country" {...country.getDropdownProps()} required />
            <SemanticFormikSelect disabled={!props.editMode} name={fn(`employmentHistory.${props.idx}.employerStateId`)} clearable label="State/Province" placeholder="Select State/Province" {...state.getDropdownProps()} required />
            {/* <SemanticFormikInput name={fn(`employmentHistory.${props.idx}.employerStateName`)} label="State/Province (textual)" maxLength={100} /> */}
        </SFormGroup>
        <SFormGroup widths="equal">
            <SemanticFormikSelect disabled={!props.editMode} name={fn(`employmentHistory.${props.idx}.employerCityId`)} clearable limit={0} placeholder="Start typing..." label="City/Town" {...cities.getDropdownProps()} required />
            {/* <SemanticFormikInput name={fn(`employmentHistory.${props.idx}.employerCityName`)} label="City/Town (textual)" maxLength={100} /> */}
            <SemanticFormikInput disabled={!props.editMode} name={fn(`employmentHistory.${props.idx}.employerPostalCode`)} label="Postal Code" maxLength={20} required />
        </SFormGroup>
        <SFormGroup widths="equal">
            <SemanticFormikInput disabled={!props.editMode} name={fn(`employmentHistory.${props.idx}.employerPhone`)} label="Employer Phone" maxLength={16} />
        </SFormGroup>
        <Header as="h4" size="tiny">Employment Period</Header>
        <SFormGroup widths="equal">
            <SemanticFormikInput disabled={!props.editMode} name={fn(`employmentHistory.${props.idx}.startDate`)} label="Start Date" type="date" />
            <SemanticFormikInput disabled={!props.editMode} name={fn(`employmentHistory.${props.idx}.endDate`)} label="End Date" type="date" />
        </SFormGroup>
    </>);
}
